<ngx-charts-pie-grid [animations]="false"
                     [scheme]="colorScheme"
                     [results]="single"
                     (select)="onSelect($event)">
</ngx-charts-pie-grid>

